export default {
    public:{
        subject: 'Chủ thể',
        author: 'tác giả',
        select: 'lọc',
        item:'dải',
        keywords: 'Từ khóa',
        load:'đang tải...',
        nodata:'Không có dữ liệu',
        close:'đóng',
        all:'tất cả',
        cancel:'Hủy bỏ',
        traditionalChinese:'truyền thống Trung Quốc',
        thai:'tiếng Thái',
        indonesian:'tiếng Indonesia',
        malay:'Mã Lai',
        filipino:'Tiếng Philippin',
        successful:'đăng ký thành công',
        loginTips: 'Vui lòng đăng nhập vào tài khoản cá nhân của bạn',
        loginSuccess: 'đăng nhập thành công',
        library:'ChatAnswer Hệ thống tham chiếu AI của thư viện',
        fellows:'ChatFellows Hệ thống khám phá/trích dẫn ngang hàng trong tổ chức',
        research:'ChatResearch là một nền tảng nghiên cứu học thuật hiệu quả và được cá nhân hóa',
        language:'ChatLanguage hệ thống dịch thuật và hiệu đính ngữ pháp thông minh AI đa ngôn ngữ',
        document:'ChatDocuments Công cụ phân tích tài liệu sâu',
        data:'ChatData Công cụ phân tích bảng sâu',
        other:'khác',
        feedSuccess:'Vấn đề phản hồi thành công!',
        codeTips:'Mã xác minh đã được gửi, vui lòng kiểm tra cẩn thận!',
        overtime:'Yêu cầu đã hết thời gian'
    },
    header:{
        feedback:'nhận xét',
        quit:'đăng xuất',
        personal:'Đăng nhập vào tài khoản cá nhân',
        language:'Ngôn ngữ đầu ra',
        username:'tên tài khoản',
        password:'mật khẩu',
        log:'Đăng nhập',
        noRegistered:'Chưa đăng ký tài khoản',
        register:'đăng ký',
        personalAccount:'Đăng ký tài khoản cá nhân',
        accountUsername:'Tài khoản người dùng',
        tips:'Vui lòng nhập tài khoản/tên người dùng',
        tipsPassword:'Xin vui lòng nhập mật khẩu',
        confirmPassword:'Xác nhận mật khẩu',
        tipsConfirmPassword:'Vui lòng xác nhận lại mật khẩu',
        email:'Email',
        tipsEmail:'vui lòng nhập email của bạn',
        phone:'Số điện thoại',
        tipsPhone:'Vui lòng nhập số điện thoại',
        verificationCode:'Mã xác minh điện thoại di động',
        tipsVerificationCode:'Vui lòng nhập mã xác minh điện thoại di động',
        sendVerificationCode:'Đạt được',
        back:'trở lại',
        module:'mô-đun chức năng',
        selectTip:'Vui lòng chọn mô-đun chức năng có vấn đề',
        question:'Mô tả vấn đề',
        screenshot:'Ảnh chụp màn hình của sự cố',
        upload:'Bấm để tải lên',
        type:'Chỉ hỗ trợ tải lên định dạng .jpg/.png',
        passwordTip:'Vui lòng nhập mật khẩu 6-24 chữ số',
        enterAgain:'Vui lòng nhập lại mật khẩu',
        inconsistent:'Mật khẩu nhập hai lần không nhất quán',
        enterCode:'vui lòng nhập mã xác nhận',
        emailTip:'Vui lòng nhập đúng địa chỉ email',
        enterEmail:'Vui lòng nhập địa chỉ email',
        otherQuestion:'Bạn có câu hỏi nào khác tương tự như vấn đề này không?',
        example:'Ví dụ',
        bibliography:'thư mục thư viện',
        logOut:'Bạn có chắc chắn muốn đăng xuất khỏi tài khoản của mình không?',
        sure:'Chắc chắn',
        switching:'Chuyển sang nhiều ngôn ngữ thành công',
        again:'Gửi lại sau vài giây',
        again2:'',
        hello:'Xin chào',
    },
    login:{
        log:'Đăng nhập',
        institutionalLogin:'Đăng nhập tổ chức',
        personalLogin:'Đăng nhập cá nhân',
        accountRegistration:'Đăng ký tài khoản',
        retrievePassword:'Lấy lại mật khẩu',
        usernameTip:'Vui lòng nhập tên người dùng tổ chức của bạn',
        personal:'Vui lòng nhập tên người dùng cá nhân của bạn',
        forget:'quên mật khẩu?',
        ipLog:'đăng nhập IP',
        institutional:'tổ chức',
        institutionalTip:'Vui lòng chọn một tổ chức',
        country:'Quốc gia',
        countryTip:'Vui lòng chọn một quốc gia',
        invitationCode:'Mã mời',
        codeTip: 'Vui lòng nhập mã mời',
        newPass:'mật khẩu mới',
        newPassTip:'Vui lòng nhập mật khẩu mới',
        elmaiCode:'Mã xác minh email',
        elmaiTip:'Vui lòng nhập mã xác minh email',
        resetting:'đặt lại mật khẩu',
        logTip: 'Tên người dùng của tổ chức không được để trống',

        truePhone:'Xin vui lòng nhập một số điện thoại hợp lệ',
        successful:'Đăng ký tài khoản thành công, vui lòng đăng nhập lại!',
        passwordReset:'Đặt lại mật khẩu thành công, vui lòng đăng nhập lại!',
        noteTitle:'Những điều cần lưu ý khi lấy mã xác minh:',
        noteOne:'1. Để đảm bảo mã xác minh có thể được gửi kịp thời và chính xác, chúng tôi khuyên bạn nên sử dụng các nhà cung cấp dịch vụ email sau: Gmail, Outkook, Yahoo;',
        noteTwo:'2. Do cơ chế lọc của mỗi nhà cung cấp dịch vụ email nên đôi khi email mã xác minh có thể bị đánh giá nhầm là email spam hoặc email không hợp lệ. Vui lòng kiểm tra xem email mã xác minh có nằm trong thùng rác spam hay không.',
    },

    chatlibrary: {
        questionOne: 'Hỏi về vấn đề mượn thư viện',
        questionTwo: 'Hỏi về các vấn đề liên quan đến cơ sở dữ liệu đã mua',
        questionThree: 'Hỏi các vấn đề liên quan đến tài nguyên số thư viện',
        quickAccess: 'Truy cập nhanh',
        disclaimer: 'Tuyên bố miễn trừ trách nhiệm',
        further:'câu hỏi thêm',
        goon:'Tiếp tục',
        statementOne: '1. Nội dung trả lời của ChatAnswer dựa trên câu trả lời cho các câu hỏi thường gặp và thông tin công khai trên các tài nguyên liên quan. Nội dung thực tế tuân theo thông tin chính thức do thư viện công bố và nội dung chính thức của các nguồn tài nguyên.',
        statementTwo: '2. Kết quả dịch thuật của chức năng dịch thuật chỉ mang tính tham khảo. Nền tảng không chịu bất kỳ trách nhiệm nào đối với bất kỳ tổn thất nào do dựa vào tính chính xác hoặc độ tin cậy của thông tin được dịch trên trang web chỉ thể hiện quan điểm; của tác giả gốc và không đại diện cho quan điểm và ý kiến ​​của nền tảng. Nó không liên quan gì đến quan điểm của nhà phát triển nền tảng.',
        statementThree: '3. Chức năng hiệu đính ngữ pháp chỉ hiệu đính dựa trên các vấn đề ngữ pháp ngôn ngữ của nội dung và không thể đạt đến mức độ đánh bóng ngôn ngữ nhân tạo. Nền tảng không chịu bất kỳ trách nhiệm nào đối với bất kỳ tổn thất nào do phụ thuộc quá nhiều vào kết quả hiệu đính ngữ pháp.',
        statementFour: '4. Nếu độc giả gửi bài tới các ấn phẩm dựa trên kết quả đề xuất tương tự thì phải xác nhận lại thông tin tạp chí và liên hệ với ban biên tập trước khi gửi. Chúng tôi sẽ không chịu trách nhiệm về mọi tổn thất do mù quáng tin vào thông tin do website cung cấp.',
        statementFive: '5. Các ý kiến ​​​​thể hiện trong các câu hỏi, yêu cầu tìm kiếm, văn bản và tệp do độc giả tải lên không thể hiện quan điểm và ý kiến ​​​​của nền tảng và không liên quan gì đến quan điểm của nhà phát triển nền tảng.',
        // 手机端
        statementOneMobile: '1. Nội dung trả lời của ChatAnswer dựa trên câu trả lời cho các câu hỏi thường gặp và thông tin công khai trên các tài nguyên liên quan. Nội dung thực tế tuân theo thông tin chính thức do thư viện công bố và nội dung chính thức của các nguồn tài nguyên.',
        statementTwoMobile: '2. Kết quả dịch thuật của chức năng dịch thuật chỉ mang tính tham khảo. Nền tảng không chịu bất kỳ trách nhiệm nào đối với bất kỳ tổn thất nào do dựa vào tính chính xác hoặc độ tin cậy của thông tin được dịch trên trang web chỉ thể hiện quan điểm; của tác giả gốc và không đại diện cho quan điểm và ý kiến ​​của nền tảng. Nó không liên quan gì đến quan điểm của nhà phát triển nền tảng.',
        statementThreeMobile: '3. Chức năng hiệu đính ngữ pháp chỉ hiệu đính dựa trên các vấn đề ngữ pháp ngôn ngữ của nội dung và không thể đạt đến mức độ đánh bóng ngôn ngữ nhân tạo. Nền tảng không chịu bất kỳ trách nhiệm nào đối với bất kỳ tổn thất nào do phụ thuộc quá nhiều vào kết quả hiệu đính ngữ pháp.',
        statementFourMobile: '4. Nếu độc giả gửi bài tới các ấn phẩm dựa trên kết quả đề xuất tương tự thì phải xác nhận lại thông tin tạp chí và liên hệ với ban biên tập trước khi gửi. Chúng tôi sẽ không chịu trách nhiệm về mọi tổn thất do mù quáng tin vào thông tin do website cung cấp.',
        statementFiveMobile: '5. Các ý kiến ​​​​thể hiện trong các câu hỏi, yêu cầu tìm kiếm, văn bản và tệp do độc giả tải lên không thể hiện quan điểm và ý kiến ​​​​của nền tảng và không liên quan gì đến quan điểm của nhà phát triển nền tảng.',

        // 进入弹窗文本
        hellow: 'Xin chào: Chào mừng bạn đã tư vấn, tôi',
        introduceOne: 'Trợ lý AI thông minh ChatAnswer rất vui được phục vụ bạn.',
        introduceTwo: '1. Giờ mở cửa thư viện',
        introduceThree: '2. Làm cách nào để tìm tài nguyên kỹ thuật số?',
        introduceFour: '3. Tôi phải làm gì nếu chẳng may cuốn sách mượn bị thất lạc?',
        introduceFive: '4. Giới thiệu cơ sở dữ liệu liên quan đến y tế',
        introduceSix: ' 5. Làm cách nào để truy cập tài nguyên kỹ thuật số của thư viện ngoài khuôn viên trường?',
        introduceSeven: 'Bạn có thể hỏi tôi những câu hỏi về thư viện, ví dụ, bạn có thể hỏi tôi "Cách tìm kiếm và tìm thấy những cuốn sách bạn cần?" "Giờ mở cửa thư viện" "Quy tắc mượn sách", v.v. Tôi sẽ cố gắng hết sức để trả lời bạn; và về Chúng tôi cũng có thể trả lời các câu hỏi về sách, cơ sở dữ liệu và các dịch vụ thư viện khác, chẳng hạn như:',
        questions: 'câu hỏi thêm',
        Continue:'Tiếp tục',
        recording:'Ghi âm nhấp chuột',
        stopRecording:'Nhấn chuột để dừng ghi',
        microphone:'Vui lòng cho phép trang này sử dụng micrô trước',
        browserTips:'Trình duyệt của bạn không hỗ trợ nhận dạng giọng nói',
        browserTips2:'Trình duyệt của bạn không hỗ trợ nhận dạng âm lượng',
        progress:'Đang nhận dạng giọng nói...',
        failed:'Nhận dạng giọng nói không thành công',
    },
    chatresearch: {
        theme: 'ChatResearch | Khám phá sâu dựa trên ngữ nghĩa',
        themeMobile: 'Khám phá sâu dựa trên ngữ nghĩa',
        switchSemantics: 'Chuyển đổi tìm kiếm ngữ nghĩa',
        switchTraditional: 'Chuyển sang tìm kiếm truyền thống',
        title: 'tiêu đề',
        results:'Kết quả nổi bật',
        source: 'nguồn',
        year: 'năm xuất bản',
        abstract: 'Bản tóm tắt',
        tips: 'Vui lòng nhập nội dung tìm kiếm...',
        select: 'xin vui lòng chọn',
        issn: 'ISSN',
        introduce_tit: 'Giới thiệu nền tảng',
        introduceOne: 'ChatResearch sẽ sử dụng trí tuệ nhân tạo và công nghệ tiên tiến để cung cấp cho độc giả một nền tảng nghiên cứu học thuật toàn diện, cá nhân hóa và hiệu quả hơn. Các chức năng cốt lõi bao gồm:',
        introduceTwo: 'Hệ thống tìm kiếm ngữ nghĩa đa ngôn ngữ: Thông qua sự hiểu biết sâu sắc về ý định và sở thích tìm kiếm của độc giả cũng như ánh xạ kiến ​​thức đa ngôn ngữ, hệ thống tìm kiếm ngữ nghĩa đa ngôn ngữ của nền tảng ChatResearch sẽ cung cấp kết quả tìm kiếm toàn diện và chính xác hơn.',
        introduceThree: 'Quản lý tài liệu hàng loạt: Các công cụ quản lý tài liệu hàng loạt có thể giúp các nhà nghiên cứu, học giả và các nhóm khác xử lý nhanh chóng lượng lớn nội dung tài liệu. Họ có thể phân loại, chú thích, tìm kiếm, lọc, chú thích, tải xuống và nhiều chức năng tự động, từ đó cải thiện đáng kể việc quản lý và quản lý tài liệu. hiệu quả công việc nghiên cứu khoa học.',
        search:'Tìm kiếm logic truyền thống',
        searchAll:'Tìm kiếm tất cả',
        searchTip:'Bạn có thể sử dụng toàn bộ văn bản tóm tắt, các đoạn văn trong tài liệu hoặc văn bản mô tả chi tiết làm nội dung tìm kiếm. Hệ thống có thể thực hiện truy xuất ngữ nghĩa dựa trên so sánh độ tương tự về ngữ nghĩa.',
        clear:'Tìm kiếm rõ ràng',
        link:'Liên kết bài viết',
        Similar:'Tài liệu tương tự',
        followingresults:'Tìm kiếm các kết quả sau',
        chinese:'người Trung Quốc',
        english:'Tiếng Anh',
        total:"Trả về tổng số kết quả",
        introduceFour:'Một hệ thống khám phá chủ đề dựa trên phân tích ngữ nghĩa và so khớp tương tự, có thể đạt được khả năng truy xuất thông minh và hiệu quả trên các ngôn ngữ.',
        volume:'Vui lòng chọn lượng tìm kiếm',
        
        inputTips:'Nội dung của ô nhập hiện tại không được để trống!'
    },
    chatlanguage: {
        enter: 'đi vào',
        errorChecking: 'Tìm lỗi ngữ pháp trong tiếng Anh',
        CToE: 'Tiếng Trung sang tiếng Anh',
        EToC: 'từ tiếng Anh sang tiếng Trung',
        docTran: 'Dịch tài liệu dịch thuật',
        functionIntroduction: 'Đặc trưng',
        introduceOne: 'Bạn có thể sử dụng chức năng "Tìm lỗi ngữ pháp tiếng Anh" để thực hiện hiệu đính ngữ pháp thông minh cho nội dung văn bản tiếng Anh. Sau khi nhập nội dung, hệ thống có thể xác định và sửa chữa các vấn đề ngữ pháp trong bài một cách thông minh. Nó hỗ trợ sửa cấu trúc câu, thì, cách sử dụng chủ ngữ và vị ngữ, dấu câu và các loại vấn đề khác, giúp nâng cao chất lượng bài viết và nâng cao khả năng đọc. và độ chính xác của cách diễn đạt.',
        introduceTwo: 'Bạn có thể sử dụng chức năng "Đánh bóng học thuật tiếng Anh" để đánh bóng và tối ưu hóa văn bản tiếng Anh. Hệ thống sẽ sửa đổi văn bản từ góc độ trôi chảy và sang trọng để làm cho văn bản mượt mà và ngắn gọn hơn. Thêm nét quyến rũ chuyên nghiệp vào văn bản và làm cho ý tưởng chủ đề xuất hiện rõ ràng hơn.',
        tips: 'Vui lòng nhập nội dung truy vấn',
        basic:'chức năng cơ bản',
        polish:'Đánh bóng học thuật tiếng Anh',
        inputTips:'Vui lòng nhập nội dung văn bản cần hiệu đính hoặc đánh bóng',

        againRequest:'Yêu cầu không thành công! Vui lòng thử lại!',
    },
    chatfellows:{
        introduceOne:'Thành tựu Nền tảng khám phá thông minh——Đứng trên vai người đi trước',
        introduceTwo:'Giới thiệu nền tảng',
        introduceThree_one:'ChatFellows',
        introduceThree_two:'Nền tảng khám phá kết quả thông minh là một',
        introduceThree:'Một công cụ tìm kiếm học thuật thông minh được tạo ra bởi các nhà nghiên cứu khoa học. Dựa trên sự tích hợp toàn diện các kết quả thể chế, tính toán độ tương tự ngữ nghĩa, công nghệ vector hóa, nhận thức ngôn ngữ tự nhiên và các công nghệ khác được áp dụng để đạt được việc sử dụng kết quả theo chiều sâu và đa chiều, đạt được kết quả khớp thông minh và chính xác, sắp xếp tương tự và nhận ra chéo -Truy xuất và kết hợp ngôn ngữ, hỗ trợ hiệu quả cho các nhà nghiên cứu khoa học trong việc thực hiện công việc nghiên cứu khoa học và viết như nghiên cứu tài liệu học thuật, truy xuất tài liệu tham khảo và lựa chọn tạp chí.',
        introduceFour:'Nền tảng khám phá thông minh kết quả tích hợp đầy đủ các kết quả nghiên cứu chính của trường chúng tôi Thông qua việc ứng dụng chuyên sâu công nghệ AI thông minh, các kết quả có thể được áp dụng một cách hiệu quả và hỗ trợ phát triển hiệu quả công việc nghiên cứu khoa học. Nó cam kết giúp người dùng tìm kiếm nhanh chóng và chính xác các bài báo chất lượng cao trong các lĩnh vực liên quan, nâng cao hiệu quả nghiên cứu và giúp đạt được kết quả học tập. Đứng trên vai những người khổng lồ và tiếp tục thúc đẩy sự tiến bộ không ngừng của nghiên cứu học thuật.',
        introduceFive:'Các chức năng cốt lõi',
        introduceSix:'Truy xuất đối sánh thông minh: thực hiện việc khám phá hiệu quả các bài báo tương tự trong các kết quả nguồn đánh giá quan trọng của trường chúng tôi.',
        introduceSeven:'Truy xuất đa ngôn ngữ: Thông qua ứng dụng công nghệ vector hóa, việc truy xuất và đối sánh được thực hiện mà không bị hạn chế về ngôn ngữ.',
        introduceTen:'Sắp xếp tối ưu hóa độ tương đồng: Các kết quả so khớp tối ưu được trình bày dựa trên độ giống nhau của các bài báo, giúp người đọc khoa học dễ dàng nhanh chóng xác định được kết quả nghiên cứu phù hợp nhất.',
        introduceEight:'Hiển thị thông tin chi tiết: Nền tảng cung cấp thông tin tài liệu chi tiết về kết quả tìm kiếm và bản dịch tóm tắt các kết quả bằng tiếng nước ngoài, cho phép người dùng nhanh chóng hiểu được ý chính của kết quả.',
        introduceNine:'Cập nhật rất kịp thời: Nền tảng thường xuyên đồng bộ hóa cơ sở dữ liệu nguồn đánh giá quan trọng để đảm bảo người đọc có thể nắm bắt được kết quả mới nhất.',
        knowBtn:'tôi hiểu rồi',
        enter:'đi vào',
        title:'Thành tựu Nền tảng khám phá thông minh——Đứng trên vai người đi trước',
        tips:'Vui lòng nhập tóm tắt hoặc chủ đề của bài viết bạn muốn tìm kiếm (tiêu đề, từ khóa, v.v.) và hệ thống sẽ giúp bạn tìm các bài viết tương tự của trường chúng tôi trong các nguồn đánh giá chính (không cần dịch hoặc chuyển đổi đặc biệt cho tiếng Trung! )',
        submit:'nộp',
        relatedLiterature:'Tài liệu liên quan',
        year:'năm',

        enSummary:'tóm tắt tiếng anh',
        cnSummary:'Tóm tắt tiếng Trung',
    },
    chatdocument:{
        title:'Công cụ phân tích tài liệu sâu',
        introduce:'Thực hiện trích xuất nội dung dữ liệu tài liệu và phân tích toàn văn về các chủ đề và phạm vi cụ thể, từ đó hỗ trợ nghiên cứu chuyên sâu.',
        start:'Bắt đầu trải nghiệm',
        ask:'Đặt câu hỏi về tài liệu và nhận được câu trả lời bạn cần',
        createSession:'Tạo cuộc trò chuyện và đặt câu hỏi trên nhiều tài liệu cùng lúc',
        quoting:'Trích dẫn đoạn văn và phân tích chuyên sâu nội dung văn học',
        analyze:'Phân tích biểu đồ và trích xuất dữ liệu để phân tích toàn diện',
        tool:"Trợ lý phân tích tài liệu hiệu quả cao",
        list:'danh sách văn học',
        conversation:'Danh sách cuộc trò chuyện',
        createAsk:'Tạo phiên',
        upload:'Tải lên tệp',
        drag:'Kéo vào tập tin hoặc nhấp để tải lên',
        introduceOne:'Đặt câu hỏi về nội dung tài liệu và nhận câu trả lời ngay lập tức thông qua trò chuyện.',
        introduceTwo:'ChatDocuments là một trợ lý phân tích cú pháp tệp có thể nhanh chóng trích xuất, định vị và tóm tắt thông tin từ các tài liệu.',
        quick:'Truy cập nhanh',
        enter:'Vui lòng nhập nội dung...',
        askQuestion:'Đặt một câu hỏi',
        example:'Ví dụ',
        busy:'Dịch vụ đang bận, vui lòng thử lại',
        stop:'Dừng trả lời',
        onlyAsk:'Chỉ đặt câu hỏi về bài viết hiện tại',
        chapter:'chương',
        create:'tạo nên',
        editsession:'chỉnh sửa phiên',
        sessionname:'tên phiên',
        currentlyselected:'Hiện đã được chọn',
        fileselection:'Lựa chọn tập tin',
        revise:'Ôn lại',
        docLanguage:'Ngôn ngữ tài liệu',
        zhDoc:'tài liệu tiếng trung',
        enDoc:'tài liệu tiếng anh',
        support:'*Chỉ hỗ trợ tải lên tập tin pdf',
        nowUpload:'Đang tải lên, vui lòng đợi...',
        question:'Ngôn ngữ tài liệu không khớp và không thể chọn được.',
        editTitle:'Nhấp đúp chuột để chỉnh sửa tên tập tin',

        uploadSuccess:'Tải lên thành công',
        sideBar:'Thu nhỏ thanh bên',
        noData:'Không tìm thấy bảng có thể phân tích cú pháp trong tài liệu',
        delConfirm:'Bạn có chắc chắn muốn xóa tập tin này?',
        unable:'Không thể phân tích excel',
        delSuccess:'đã xóa thành công',
        selFile:'Vui lòng chọn tập tin',
        inputName:'Vui lòng nhập tên phiên',
        createSuccess:'Đã tạo thành công',
        fileTips:'File đang được chuyển đổi, vui lòng thử lại sau',
        failFile:'Việc chuyển đổi tập tin không thành công, vui lòng tải lên lại',
        defaultQuestion1:'Những trường nào được bao gồm trong bảng và dữ liệu nào được mô tả?',
        defaultQuestion2:'Hãy tính trung bình cộng của từng cột dữ liệu?',
        defaultQuestion3:'Hãy tính số trung vị của mỗi cột dữ liệu?',
        defaultQuestion4:'Giá trị nào xuất hiện thường xuyên nhất trong mỗi cột dữ liệu?',
        defaultQuestion5:'Chúng ta có thể nhận được thông tin gì từ dữ liệu trong bảng và chúng ta có thể rút ra kết luận gì từ phân tích?',
    },
    chatdata:{
        title:'Công cụ phân tích thông minh dữ liệu sâu',
        introduce:'Khám phá những hiểu biết sâu sắc từ dữ liệu của bạn thông qua phân tích cú pháp thông minh và phân tích sâu. Sử dụng chức năng phân tích trực quan để hiển thị sống động dưới dạng biểu đồ.',
        start:'Bắt đầu trải nghiệm',
        ask:'Đặt câu hỏi về tài liệu và nhận được câu trả lời bạn cần',
        create:'Tạo cuộc trò chuyện và đặt câu hỏi trên nhiều tài liệu cùng lúc',
        quoting:'Trích dẫn đoạn văn và phân tích chuyên sâu nội dung văn học',
        analyze:'Phân tích biểu đồ và trích xuất dữ liệu để phân tích toàn diện',
        tool:"Trợ lý phân tích tài liệu hiệu quả cao",
        list:'danh sách văn học',
        conversation:'Danh sách cuộc trò chuyện',
        createAsk:'Tạo phiên',
        upload:'Tải lên tệp',
        drag:'Kéo vào tập tin hoặc nhấp để tải lên',
        introduceOne:'ChatData cho phép đặt câu hỏi đàm thoại bằng bảng thông qua phân tích thông minh về bảng và tập dữ liệu. Và thông qua phân tích chuyên sâu, các biểu đồ trực quan có thể được tạo tự động để làm cho dữ liệu rõ ràng trong nháy mắt!',
        quick:'Truy cập nhanh',
        enter:'Vui lòng nhập nội dung...',
        hint:'gợi ý',
        hintOne:'Xin lưu ý rằng mô-đun này đang được bảo trì và tạm thời không khả dụng. Cảm ơn sự thông cảm và kiên nhẫn của bạn trong việc lựa chọn tệp.',
        Isee:'tôi hiểu rồi',
    },
    chatopen:{
        title:'Công cụ khám phá kiến ​​thức mở của bạn',
        switch:'Chuyển sang tìm kiếm truyền thống',
        introduce:'Thu thập và khám phá các kết quả nghiên cứu khoa học mới nhất về vật lý, toán học, khoa học máy tính, trí tuệ nhân tạo, thống kê, v.v. và nắm bắt xu hướng phát triển',
        features:'Đặc trưng',
        featureOne:'Sử dụng trí tuệ nhân tạo và công nghệ tiên tiến để cung cấp cho các nhà nghiên cứu khoa học trải nghiệm khám phá kiến ​​thức hiệu quả, mạnh mẽ và chính xác hơn. ChatOpen áp dụng công nghệ truy xuất ngữ nghĩa để đạt được sự hiểu biết sâu sắc về ý định tìm kiếm, sở thích và ánh xạ đa ngôn ngữ của người đọc.',
        featureTwo:'Tích hợp siêu dữ liệu kiến ​​thức mở khổng lồ để cung cấp cho người đọc khoa học nhiều loại kết quả học thuật nguồn mở bao gồm các tài liệu truy cập mở, bản in trước, v.v. Kết hợp với khám phá ngữ nghĩa, chúng tôi hy vọng những tài nguyên này có thể giúp bạn thúc đẩy đổi mới nghiên cứu học thuật và kết nối bạn với tương lai mở.',
        translate:'dịch',
        clear:'LÀm sạch bộ lọc'
    },
    message:{
        authority: "Không có quyền",
        upload: "Chỉ hỗ trợ định dạng .jpg/.png!",
        apply: "Yêu cầu dùng thử đã được gửi, vui lòng chờ đợi!",
        delete: "Bạn có chắc chắn muốn xóa tệp này không?",
        size: "Kích thước tệp không được vượt quá 20MB",
        wait: "Đang xử lý, vui lòng đợi"
    }
}
